import React, { useState } from 'react'

import { Text, Button } from '@components/UI'
import Stars from '@components/Rating'

const Rating = ({ small, person, onSubmit }) => {
  const [value, setValue] = useState(null)

  return (
    <div className='gp-feedback-rating'>
      <div>
        <Text
          className={`${small ? 'text-c' : 'text-e'}`}
          style={{
            color: 'rgba(255, 255, 255, .45)'
          }}
        >
          Please rate your experience with
          <font
            className='semibold'
            style={{ color: 'rgba(255, 255, 255, .75)' }}
          >
            {' '}
            {person.name}
          </font>
        </Text>
        <Stars
          big
          value={value}
          style={{ marginTop: 16 }}
          interactive
          onChange={(value) => setValue(value)}
        />
      </div>
      <div className='actions-container'>
        <Button
          className='medium'
          theme='c interactive'
          disabled={!value}
          inverted
          group={small ? 'a3' : 'a4'}
          icon={{
            name: 'star',
            value: 'Rate',
            group: small ? 'a' : 'a2'
          }}
          events={{
            onClick: () => onSubmit(value)
          }}
        />
      </div>
    </div>
  )
}

export default Rating
